export const captchaSiteKey = "6LeY1JcUAAAAAJAX60BKWCDzvP0X5-hd5pUpP4VI";

export const stripeApiKey = "pk_test_AS0ttYEuG5tg6dAGjURur35h";

// export const stripeApiKey = "pk_test_DT8tZwOEppaXJXFFhj6impY9" // My test api key